/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultReferentialQuickMessage } from '../../models/api-response-paged-result-referential-quick-message';
import { PagedRequestReferentialQuickMessageSearch } from '../../models/paged-request-referential-quick-message-search';

export interface SearchReferentialQuickMessage$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestReferentialQuickMessageSearch
}

export function searchReferentialQuickMessage(http: HttpClient, rootUrl: string, params: SearchReferentialQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialQuickMessage>> {
  const rb = new RequestBuilder(rootUrl, searchReferentialQuickMessage.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultReferentialQuickMessage>;
    })
  );
}

searchReferentialQuickMessage.PATH = '/v1/api/ui/referential/quick-message/search';
